import {
  LOADING_GOVERNMENT_UI,
  LOADING_POLITICALPARTY_UI,
  LOADING_POLITICIAN_UI,
  LOADING_UI,
  START_LOADING_USER,
  STOP_LOADING_GOVERNMENT_UI,
  STOP_LOADING_POLITICALPARTY_UI,
  STOP_LOADING_POLITICIAN_UI,
  STOP_LOADING_UI,
  STOP_LOADING_USER,
  UiDispatchTypes,
} from "../../types/ui/UiReducerTypes";

interface UiInitialState {
  loading: boolean;
  userLoading: boolean;
  governmentLoading: boolean;
  politicalPartyLoading: boolean;
  politicianLoading: boolean;
}
const initialState: UiInitialState = {
  loading: false,
  userLoading: false,
  governmentLoading: false,
  politicalPartyLoading: false,
  politicianLoading: false,
};

const UiReducer = (
  state: UiInitialState = initialState,
  action: UiDispatchTypes
): UiInitialState => {
  switch (action.type) {
    case LOADING_UI:
      return {
        ...state,
        loading: true,
      };
    case STOP_LOADING_UI:
      return {
        ...state,
        loading: false,
      };
    case LOADING_POLITICIAN_UI:
      return {
        ...state,
        politicianLoading: true,
      };
    case STOP_LOADING_POLITICIAN_UI:
      return {
        ...state,
        politicianLoading: false,
      };
    case LOADING_GOVERNMENT_UI:
      return {
        ...state,
        governmentLoading: true,
      };
    case STOP_LOADING_GOVERNMENT_UI:
      return {
        ...state,
        governmentLoading: false,
      };
    case LOADING_POLITICALPARTY_UI:
      return {
        ...state,
        politicalPartyLoading: true,
      };
    case STOP_LOADING_POLITICALPARTY_UI:
      return {
        ...state,
        politicalPartyLoading: false,
      };
    case START_LOADING_USER:
      return {
        ...state,
        userLoading: true,
      };
    case STOP_LOADING_USER:
      return {
        ...state,
        userLoading: false,
      };

    default:
      return state;
  }
};
export default UiReducer;
